import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Icon from '../../atoms/Icon';
import { getPaymentOptionsLabel } from '../../../utils';


/**
 * A simple PaymentSelectorOption.
 */

class PaymentSelectorOption extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		  isset: false
		};
	  }

	componentDidUpdate(prevProps, prevState) {
		if(this.props.onlyOption && this.props.active && this.props.paymentOption!==this.props.id && prevState.isset===false) {
			this.setState({
				isset: true
			},
				function() {
					this.props.onClick(this.props.type, this.props.choice, this.props.id);
				}
			);
			
		}
	}

	handleClick() {
		if(this.props.active) {
			this.props.onClick(this.props.type, this.props.choice, this.props.id);
		}
	}

    render () {
    	const { label, subline } = getPaymentOptionsLabel(this.props.type, this.props.choice);
        return (
          <div className={`paymentselectoroption${this.props.active?" active":""}${this.props.paymentOption===this.props.id?" selected":""}`} onClick={() => this.handleClick()}>
            <div className="toggleselect"><Icon filename="selected" /></div>
            <div className="inner">
            	<div className="desc">
	            	<h4 style={{color:(this.props.active?"black":"grey")}}>
	              		{label}
	              	</h4>
	              	{subline!==''?
	              	<div className="subline" style={{color:(this.props.active?"black":"grey")}}>
	              		{subline}
	              	</div>
	              	:null}
            	</div>
            </div>
          </div>
        );
    }

}

PaymentSelectorOption.propTypes = {
	/** Button label */
	choice: PropTypes.object.isRequired,
	/** type */
	type: PropTypes.string.isRequired,
	/** Gets called when the user clicks on the item */
	onClick: PropTypes.func,
	/** boolean */
	active: PropTypes.bool,
	/** boolean */
	selected: PropTypes.bool,

	onlyOption: PropTypes.bool,
}

PaymentSelectorOption.defaultProps = {
	/* eslint-disable no-console */
	onClick: event => {
		console.log('You have clicked a PaymentSelectorOption Component!', event.target);
	},
	/* eslint-enable no-console */
	active: false,
	selected: false,
	onlyOption: false
	
}


const mapStateToProps = (state) => {
  return {
    paymentOption: state.status.payment.paymentOption
  }
}


export default connect(
  mapStateToProps,
  null
)(PaymentSelectorOption)







// WEBPACK FOOTER //
// ./src/components/molecules/PaymentSelectorOption/PaymentSelectorOption.js